// extracted by mini-css-extract-plugin
export default {"fullWidth":"_1pX0z"};